// AUTO-GENERATED — do not edit.
// Source: business/ishvaram/data/governance/intent_offer_alignment.yaml
// Regenerate: uv run python execution/generate_intent_offer_ts.py

/** A page-intent and the offer it must sell (message-match contract, rule 40). */
export interface IntentOfferRule {
  intent: string;
  pageArchetypes: string[];
  primaryOffer: string;
  /** Immutable next-report target for a verified purchase of primaryOffer. */
  postPurchaseOffer?: string;
  secondaryOffers: string[];
  /** The offer that must stay surfaced on this intent's pages — never buried. */
  neverBury: string;
  lifecycleStage: string;
  /**
   * Tier-scoped primary override (rule 40): when the paywall's exhausted_tier
   * matches a key, that offer outranks primaryOffer — IF the plan is present
   * in the paywall payload (feature flag + experiment arm gate presence).
   * The neverBury offer stays surfaced in the disclosure either way.
   */
  exhaustedTierOverrides?: Record<string, string>;
}

export const INTENT_OFFER_RULES: IntentOfferRule[] = [
  {
    "intent": "chat",
    "pageArchetypes": [
      "ai_astrologer",
      "free_astrology_chat",
      "chat_landing",
      "ai_jyotish",
      "talk_to_astrologer",
      "chat_with_astrologer"
    ],
    "primaryOffer": "quick",
    "secondaryOffers": [
      "day_pass",
      "ask_one_question",
      "brihat_kundali",
      "resolution_7d"
    ],
    "neverBury": "quick",
    "lifecycleStage": "conversion",
    "exhaustedTierOverrides": {
      "session_expired": "resolution_7d"
    }
  },
  {
    "intent": "dosha_remedy",
    "pageArchetypes": [
      "sade_sati",
      "mangal_dosh",
      "kaal_sarp_dosh",
      "pitra_dosh",
      "dosha_page",
      "dosha_report",
      "shani"
    ],
    "primaryOffer": "dosha_remedy_plan",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "dosha_remedy_plan",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "matching",
    "pageArchetypes": [
      "kundali_milan",
      "compatibility",
      "matching_tool",
      "gun_milan",
      "marriage_report",
      "astrologer_for_marriage_problem"
    ],
    "primaryOffer": "marriage_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "marriage_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "birth_chart",
    "pageArchetypes": [
      "free_kundali",
      "birth_chart",
      "kundali",
      "janam_kundli"
    ],
    "primaryOffer": "brihat_kundali",
    "secondaryOffers": [
      "quick",
      "starter"
    ],
    "neverBury": "brihat_kundali",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "annual_forecast"
  },
  {
    "intent": "career",
    "pageArchetypes": [
      "career",
      "career_report",
      "career_finance",
      "job",
      "business",
      "career_astrology_consultation"
    ],
    "primaryOffer": "career_report",
    "secondaryOffers": [
      "brihat_kundali",
      "dosha_remedy_plan",
      "quick"
    ],
    "neverBury": "career_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "timing",
    "pageArchetypes": [
      "panchang",
      "muhurat",
      "choghadiya",
      "shubh_muhurat"
    ],
    "primaryOffer": "muhurat_report",
    "secondaryOffers": [
      "quick",
      "day_pass"
    ],
    "neverBury": "muhurat_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "forecast",
    "pageArchetypes": [
      "rashifal",
      "horoscope",
      "annual_forecast_page",
      "year_ahead",
      "daily_horoscope"
    ],
    "primaryOffer": "annual_forecast",
    "secondaryOffers": [
      "brihat_kundali"
    ],
    "neverBury": "annual_forecast",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "festival_ritual",
    "pageArchetypes": [
      "festival",
      "puja",
      "vrat",
      "festival_ritual"
    ],
    "primaryOffer": "muhurat_report",
    "secondaryOffers": [
      "quick",
      "brihat_kundali"
    ],
    "neverBury": "muhurat_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "pitra_dosh_report",
    "pageArchetypes": [
      "pitra_dosh_report",
      "pitra_dosha_report"
    ],
    "primaryOffer": "pitra_dosh",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "pitra_dosh",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "sade_sati_report",
    "pageArchetypes": [
      "sade_sati_report",
      "shani_report"
    ],
    "primaryOffer": "sade_sati",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "sade_sati",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "mahadasha_forecast",
    "pageArchetypes": [
      "mahadasha",
      "dasha_calculator",
      "mahadasha_forecast_page"
    ],
    "primaryOffer": "mahadasha_forecast",
    "secondaryOffers": [
      "annual_forecast",
      "brihat_kundali"
    ],
    "neverBury": "mahadasha_forecast",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "trigger_reentry",
    "pageArchetypes": [
      "trigger_reentry",
      "kundali_update"
    ],
    "primaryOffer": "mahadasha_forecast_winback",
    "secondaryOffers": [
      "sade_sati_winback",
      "quick",
      "mahadasha_forecast",
      "sade_sati",
      "brihat_kundali"
    ],
    "neverBury": "quick",
    "lifecycleStage": "retention"
  },
  {
    "intent": "numerology",
    "pageArchetypes": [
      "numerology",
      "name_numerology",
      "ank_jyotish",
      "numerology_calculator"
    ],
    "primaryOffer": "numerology_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "numerology_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "gemstone",
    "pageArchetypes": [
      "gemstone",
      "lucky_gemstone",
      "ratna",
      "rudraksha",
      "gemstone_recommendation"
    ],
    "primaryOffer": "gemstone_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "gemstone_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "baby_name",
    "pageArchetypes": [
      "baby_name",
      "namkaran",
      "baby_name_finder"
    ],
    "primaryOffer": "baby_name_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "baby_name_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "lal_kitab",
    "pageArchetypes": [
      "lal_kitab",
      "lal_kitab_remedy"
    ],
    "primaryOffer": "lal_kitab_report",
    "secondaryOffers": [
      "brihat_kundali",
      "quick"
    ],
    "neverBury": "lal_kitab_report",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  },
  {
    "intent": "gochar",
    "pageArchetypes": [
      "gochar",
      "transit",
      "gochar_forecast"
    ],
    "primaryOffer": "transit_forecast",
    "secondaryOffers": [
      "sade_sati",
      "brihat_kundali"
    ],
    "neverBury": "transit_forecast",
    "lifecycleStage": "conversion",
    "postPurchaseOffer": "brihat_kundali"
  }
];

export function offerRuleForArchetype(archetype: string): IntentOfferRule | null {
  return INTENT_OFFER_RULES.find((r) => r.pageArchetypes.includes(archetype)) ?? null;
}

export function primaryOfferForIntent(intent: string): string | null {
  return INTENT_OFFER_RULES.find((r) => r.intent === intent)?.primaryOffer ?? null;
}
